import React from "react";
import { Typography } from "@material-ui/core";

import { FORM_CONSTANTS } from "../../../constants";
import { CATEGORY } from "../../../constants/enums";
import { QCV2026_LINKS } from "../../../constants/qcv2026.config";

// 10 lĩnh vực xét giải QCV 2026 (đồng bộ với FIELD_OPTIONS + tooltip lưu ý + ưu tiên)
const FIELDS = FORM_CONSTANTS.FIELD_OPTIONS[CATEGORY.QCV];

// "(1) Điều kiện xét giải" có cấu trúc giống nhau cho mọi lĩnh vực, chỉ đổi tên lĩnh vực
const renderConditions = (linhVuc) => (
  <>
    <p>(1) Điều kiện xét giải:</p>
    <p>
      - Là tác giả bằng độc quyền sáng chế, bằng độc quyền giải pháp hữu ích
      trong lĩnh vực {linhVuc} hoặc sáng chế đã được áp dụng thành công trong
      thực tế.
    </p>
    <p>
      - Là tác giả các công trình nghiên cứu khoa học trong lĩnh vực {linhVuc} đã
      được công bố trên các tạp chí chuyên ngành uy tín trong và ngoài nước; các
      báo cáo khoa học tại hội nghị khoa học chuyên ngành uy tín quốc gia, quốc
      tế.
    </p>
    <p>
      - Chủ trì, đồng chủ trì các đề tài nghiên cứu khoa học trong lĩnh vực{" "}
      {linhVuc} đã nghiệm thu đạt yêu cầu.
    </p>
    <p>
      - Là tác giả, chủ biên các giáo trình, sách chuyên khảo, chương sách chuyên
      ngành trong lĩnh vực {linhVuc} đã được các nhà xuất bản uy tín trong hoặc
      ngoài nước phát hành.
    </p>
    <p>
      - Là người sáng lập/điều hành dự án, doanh nghiệp khởi nghiệp trong lĩnh
      vực {linhVuc} thu hút được đầu tư từ Nhà nước, các quỹ đầu tư có uy tín hoặc
      có sản phẩm, giải pháp được ứng dụng, thương mại hóa, tạo giá trị thực tiễn
      mang lại hình ảnh và thương hiệu Make in Vietnam.
    </p>
    <p>
      - Đạt giải cao trong các kỳ thi quốc tế uy tín và đạt các giải thưởng, huy
      chương, bằng khen các cuộc thi uy tín cấp quốc gia trong lĩnh vực {linhVuc}.
    </p>
  </>
);

export default function QuyChe() {
  return (
    <div className="formal-text" style={{ padding: 8 }}>
      <Typography variant="h5">
        <strong>1. Đối tượng xét Giải thưởng&nbsp;</strong>
      </Typography>
      <p>
        Giải thưởng xét trao cho các cá nhân là công dân Việt Nam không quá 35
        tuổi (tính đến ngày 31/12 của năm xét trao giải), đang học tập, nghiên
        cứu, làm việc ở trong nước hoặc nước ngoài trong lĩnh vực khoa học công
        nghệ, đổi mới sáng tạo và chuyển đổi số.
      </p>
      <Typography variant="h5">
        <strong>2. Tiêu chí xét Giải thưởng</strong>
      </Typography>
      <br />
      <Typography variant="h6">
        <i>
          <strong>2.1. Tiêu chí chung&nbsp;</strong>
        </i>
      </Typography>
      <p>
        - Có thành tích xuất sắc trong học tập, nghiên cứu, làm việc; có công
        trình nghiên cứu, giải pháp khoa học công nghệ nổi bật trong các lĩnh vực
        khoa học công nghệ, đổi mới sáng tạo và chuyển đổi số; có giá trị khoa
        học và thực tiễn cao; có ý tưởng sáng tạo được ứng dụng rộng rãi trong
        thực tế, góp phần làm chủ công nghệ, phát triển các công nghệ chiến lược,
        phục vụ sự phát triển đất nước trong kỷ nguyên số.
      </p>
      <p>
        - Có phẩm chất đạo đức, ý thức kỷ luật, chấp hành đường lối của Đảng,
        pháp luật của Nhà nước Việt Nam và nước sở tại (đối với công dân Việt Nam
        ở nước ngoài); có ý chí vươn lên trong học tập, công tác; có uy tín và
        ảnh hưởng tốt trong thanh thiếu nhi và xã hội, thể hiện tinh thần trách
        nhiệm xã hội, đóng góp tích cực cho sự phát triển bền vững của đất nước.
      </p>
      <p>
        - Ưu tiên, khuyến khích người dân tộc thiểu số, người khuyết tật; các cá
        nhân vừa là nhà khoa học, nhà sáng chế vừa là lãnh đạo chủ chốt các tổ
        chức khoa học công nghệ, doanh nghiệp hoạt động trong các lĩnh vực công
        nghệ chiến lược, tiên phong trong khởi nghiệp khoa học công nghệ, đổi mới
        sáng tạo và chuyển đổi số, tạo ra các giá trị sản phẩm hàng hoá, dịch vụ
        có hàm lượng khoa học công nghệ cao trên thị trường và đóng góp tích cực
        cho sự phát triển kinh tế, xã hội của đất nước.
      </p>
      <Typography variant="h6">
        <i>
          <strong>2.2. Tiêu chí trong lĩnh vực cụ thể</strong>
        </i>
      </Typography>
      <p>
        Mỗi hồ sơ chỉ đăng ký một lĩnh vực xét giải thưởng. Trường hợp hồ sơ có
        tính liên ngành, lĩnh vực đăng ký được xác định theo công trình nghiên
        cứu, sản phẩm, công nghệ cốt lõi, phù hợp với nội dung ưu tiên của lĩnh
        vực đăng ký. Không xác định lĩnh vực đăng ký theo công nghệ phụ trợ, công
        cụ hỗ trợ. Trường hợp công nghệ nền tảng được nghiên cứu, phát triển,
        tích hợp để tạo thành sản phẩm, hệ thống, quy trình hoặc giải pháp chuyên
        dùng cho một lĩnh vực cụ thể thì hồ sơ đăng ký theo lĩnh vực chuyên dùng
        đó. Trường hợp công nghệ nền tảng có tính ứng dụng chung, chưa tạo thành
        sản phẩm, hệ thống, quy trình hoặc giải pháp chuyên dùng cho một lĩnh vực
        cụ thể thì hồ sơ đăng ký theo lĩnh vực công nghệ nền tảng tương ứng. Việc
        xác định lĩnh vực đăng ký căn cứ vào giá trị khoa học, công nghệ và đóng
        góp cốt lõi của công trình, sản phẩm, giải pháp đề nghị xét giải. Hồ sơ
        đăng ký không đúng lĩnh vực sẽ không được đưa vào xét giải. Cá nhân được
        xét trao tặng Giải thưởng phải phù hợp với lĩnh vực đăng ký xét giải và
        đáp ứng ít nhất một trong các điều kiện sau đây:
      </p>
      {FIELDS.map((f, idx) => (
        <div key={f.value}>
          <Typography variant="h6" style={{ marginTop: 12 }}>
            <i>
              <strong>{`2.2.${idx + 1}. Lĩnh vực ${f.title}`}</strong>
            </i>
          </Typography>
          {renderConditions(f.title)}
          {f.priority ? (
            <>
              <p>(2) Ưu tiên:</p>
              <p>{f.priority}</p>
            </>
          ) : null}
          {f.note ? (
            <>
              <p>(3) Lưu ý đăng ký hồ sơ:</p>
              <p>
                <i>{f.note}</i>
              </p>
            </>
          ) : null}
        </div>
      ))}
      {QCV2026_LINKS.quyetDinhQuyChe ? (
        <p>
          <i>
            Toàn văn Quy chế và Quyết định ban hành Giải thưởng xem{" "}
            <a
              href={QCV2026_LINKS.quyetDinhQuyChe}
              target="_blank"
              rel="noreferrer"
            >
              tại đây
            </a>
            .
          </i>
        </p>
      ) : null}
      <Typography variant="h5">
        <strong>3. Hình thức giải thưởng</strong>
      </Typography>
      <p>Mỗi cá nhân đạt Giải thưởng sẽ được nhận:</p>
      <p>
        - Bằng khen của Ban Chấp hành Trung ương Đoàn TNCS Hồ Chí Minh;
      </p>
      <p>
        - Giấy chứng nhận của Bộ Khoa học và Công nghệ và Trung ương Đoàn TNCS
        Hồ Chí Minh;&nbsp;
      </p>
      <p>- Biểu trưng Giải thưởng;</p>
      <p>- Phần thưởng bằng tiền mặt tối thiểu 20 triệu đồng;</p>
      <p>- Các phần thưởng khác của đơn vị tài trợ, bảo trợ (nếu có).</p>
      <Typography variant="h5">
        <strong>
          4. Cơ cấu, số lượng và tiêu chí đánh giá đề cử Giải thưởng&nbsp;
        </strong>
      </Typography>
      <br />
      <Typography variant="h6">
        <i>
          <strong>4.1. Cơ cấu, số lượng Giải thưởng</strong>
        </i>
      </Typography>
      <p>
        Giải thưởng được trao hằng năm. Căn cứ vào số lượng, chất lượng hồ sơ đề
        cử và kết quả thẩm định, đánh giá của Hội đồng Giải thưởng Khoa học công
        nghệ Quả Cầu Vàng (sau đây gọi tắt là Hội đồng Giải thưởng), Hội đồng
        Giải thưởng đề xuất cơ cấu và số lượng giải thưởng theo từng lĩnh vực xét
        giải. Số lượng cá nhân được trao Giải thưởng hằng năm không quá 10 người.
      </p>
      <Typography variant="h6">
        <i>
          <strong>4.2. Tiêu chí đánh giá đề cử Giải thưởng</strong>
        </i>
      </Typography>
      <p>
        Việc đánh giá, xét chọn các đề cử Giải thưởng được thực hiện trên cơ sở
        bảo đảm công khai, minh bạch, khách quan, căn cứ vào các tiêu chí chủ yếu
        sau đây, làm cơ sở để cá nhân chuẩn bị hồ sơ tham gia xét giải thưởng:
      </p>
      <p>
        1. Bảo đảm liêm chính khoa học, tuân thủ các chuẩn mực đạo đức nghiên
        cứu, trung thực trong học thuật, sở hữu trí tuệ và công bố khoa học.
      </p>
      <p>
        2. Các phát minh, sáng chế, giải pháp, sản phẩm khoa học công nghệ có giá
        trị khoa học và ứng dụng trong thực tiễn, mang lại hiệu quả kinh tế - xã
        hội, đóng góp thiết thực cho phát triển ngành, địa phương và đất nước.
      </p>
      <p>
        3. Chất lượng các công bố khoa học trong nước và quốc tế, bao gồm: các
        bài báo, sách, chương sách, báo cáo khoa học tại các tạp chí, hội nghị
        khoa học uy tín.
      </p>
      <p>
        4. Năng lực xây dựng và dẫn dắt nhóm nghiên cứu, năng lực chủ trì hoặc
        tham gia chủ trì các đề tài, chương trình, dự án nghiên cứu khoa học các
        cấp, đặc biệt là cấp quốc gia và quốc tế.
      </p>
      <p>
        5. Thành tích khoa học công nghệ nổi bật, có công trình tiêu biểu thể
        hiện rõ dấu ấn khoa học, năng lực chuyên môn và đóng góp nổi bật của cá
        nhân.
      </p>
      <p>
        6. Đạt các danh hiệu: các giải thưởng, huy chương, bằng khen, danh hiệu
        uy tín trong nước hoặc quốc tế.
      </p>
      <p>
        7. Tham gia đóng góp công tác đào tạo, bồi dưỡng và phát triển nguồn nhân
        lực khoa học công nghệ, chia sẻ và chuyển giao tri thức cho cộng đồng và
        thế hệ trẻ.
      </p>
      <p>
        8. Cam kết và kế hoạch hành động của cá nhân sau khi đạt Giải thưởng, bao
        gồm các hoạt động đồng hành cùng Giải thưởng, hỗ trợ phát triển thế hệ
        trẻ, chia sẻ tri thức, truyền cảm hứng và đóng góp cho cộng đồng trong
        thời gian tối thiểu 03 năm kể từ thời điểm được trao Giải thưởng.
      </p>
      <p>
        Ngoài các tiêu chí trên, Hội đồng Giải thưởng xem xét, đánh giá thêm các
        yếu tố khác phù hợp với từng lĩnh vực xét giải và yêu cầu thực tiễn, như:
        Mức độ ảnh hưởng, lan tỏa của kết quả nghiên cứu đối với xã hội; khả năng
        kết nối, huy động các nguồn lực cho nghiên cứu khoa học, đổi mới sáng
        tạo; vai trò tiên phong, dẫn dắt trong hệ sinh thái khoa học công nghệ,
        đổi mới sáng tạo và chuyển đổi số. Việc áp dụng các tiêu chí đánh giá
        được thực hiện linh hoạt, phù hợp với đặc thù từng lĩnh vực, từng nhóm
        đối tượng.
      </p>
      <Typography variant="h5">
        <strong>5. Quyền lợi của cá nhân được nhận Giải thưởng</strong>
      </Typography>
      <br />
      <Typography variant="h6">
        <i>
          <strong>5.1. Đối với cá nhân được nhận Giải thưởng</strong>
        </i>
      </Typography>
      <p>- Được nhận Giải thưởng theo quy định tại Điều 6 của Quy chế này.</p>
      <p>
        - Được ghi danh, lưu hồ sơ cá nhân trong Hệ thống Cơ sở dữ liệu Tài năng
        trẻ Quốc gia; được xem xét, giới thiệu tham gia các sự kiện, diễn đàn tài
        năng trẻ, chương trình giao lưu, kết nối, hợp tác trong nước và quốc tế
        do Trung ương Đoàn TNCS Hồ Chí Minh và các bộ, ngành, đơn vị liên quan
        tổ chức.
      </p>
      <p>
        - Được Trung tâm Phát triển Khoa học, Công nghệ và Tài năng trẻ, Quỹ Hỗ
        trợ Tài năng trẻ Việt Nam, tổ chức Đoàn các cấp và các bộ, ban, ngành
        liên quan xem xét hỗ trợ, đồng hành trong học tập, nghiên cứu khoa học,
        đổi mới sáng tạo, chuyển giao công nghệ và phát triển nghề nghiệp, phù
        hợp với chức năng, nhiệm vụ và điều kiện thực tế của từng đơn vị.
      </p>
      <p>- Mỗi cá nhân chỉ được nhận Giải thưởng một lần.</p>
      <Typography variant="h6">
        <i>
          <strong>
            5.2. Đối với cá nhân đạt ứng viên tiêu biểu (TOP20)
          </strong>
        </i>
      </Typography>
      <p>
        - Được nhận Giấy chứng nhận của Ban Tổ chức Giải thưởng là ứng viên tiêu
        biểu của Giải thưởng.
      </p>
      <p>
        - Được giới thiệu tham gia các sự kiện, diễn đàn tài năng trẻ, chương
        trình giao lưu, kết nối, hợp tác trong nước và quốc tế do Trung ương Đoàn
        TNCS Hồ Chí Minh và các bộ, ngành, đơn vị liên quan tổ chức.
      </p>
      <p>
        - Được Đơn vị thường trực Giải thưởng xem xét, đề xuất tiếp tục tham gia
        xét Giải thưởng ở năm tiếp theo nếu còn bảo đảm điều kiện, độ tuổi và cập
        nhật đầy đủ hồ sơ theo yêu cầu; ứng viên không phải thực hiện lại quy
        trình giới thiệu tại đơn vị chủ quản như lần đầu tham gia xét giải.
      </p>
      <Typography variant="h5">
        <strong>6. Nghĩa vụ của cá nhân được nhận Giải thưởng</strong>
      </Typography>
      <p>Cá nhân được nhận Giải thưởng có các nghĩa vụ sau:</p>
      <p>
        - Giữ gìn phẩm chất đạo đức, liêm chính khoa học và uy tín nghề nghiệp;
        tích cực tham gia, đóng góp nâng cao chất lượng, uy tín và giá trị lan
        tỏa của giải thưởng; phát huy vai trò nòng cốt, truyền cảm hứng trong các
        phong trào, hoạt động phát triển tài năng trẻ do tổ chức Đoàn TNCS Hồ Chí
        Minh các cấp và các cơ quan, đơn vị liên quan tổ chức.
      </p>
      <p>
        - Tham gia đóng góp ý kiến, đề xuất sáng kiến trong việc xây dựng, hoàn
        thiện các chủ trương, chính sách của Đảng, Nhà nước và của tổ chức Đoàn
        TNCS Hồ Chí Minh liên quan đến công tác phát hiện, bồi dưỡng, phát huy
        tài năng trẻ Việt Nam, phù hợp với lĩnh vực chuyên môn, kinh nghiệm và
        điều kiện thực tế của cá nhân.
      </p>
      <p>
        - Phối hợp, cung cấp thông tin cần thiết cho Ban Tổ chức Giải thưởng phục
        vụ công tác tổng kết, đánh giá, báo cáo tác động và truyền thông về Giải
        thưởng. Trách nhiệm thực hiện các nội dung cam kết sau khi đạt giải
        thưởng, cụ thể như sau:
      </p>
      <p>
        + Đồng hành cùng Giải thưởng thông qua việc tham gia các hoạt động chuyên
        môn, học thuật, truyền cảm hứng do Đơn vị thường trực Giải thưởng, Trung
        ương Đoàn TNCS Hồ Chí Minh hoặc đơn vị được ủy quyền tổ chức.
      </p>
      <p>
        + Hỗ trợ phát triển thế hệ trẻ, tham gia tư vấn, hướng dẫn, cố vấn cho
        học sinh, sinh viên, nhà khoa học trẻ, nhóm nghiên cứu trẻ, dự án khởi
        nghiệp khoa học công nghệ (trực tiếp hoặc trực tuyến, phù hợp điều kiện
        thực tế).
      </p>
      <p>
        + Chia sẻ tri thức, kinh nghiệm chuyên môn trong học tập, nghiên cứu,
        khởi nghiệp, ứng dụng khoa học công nghệ và thúc đẩy văn hóa liêm chính
        khoa học, đổi mới sáng tạo.
      </p>
      <p>
        + Tham gia đóng góp xây dựng hệ sinh thái khoa học công nghệ và đổi mới
        sáng tạo, kết nối, hỗ trợ các mạng lưới tài năng trẻ trong khả năng cho
        phép.
      </p>
      <p>
        + Thực hiện các nội dung cam kết trong thời gian tối thiểu 03 (ba) năm kể
        từ thời điểm được trao giải thưởng, phù hợp với lĩnh vực chuyên môn và
        điều kiện thực tế của cá nhân.
      </p>
      <Typography variant="h5">
        <strong>7. Xử lý các trường hợp vi phạm</strong>
      </Typography>
      <p>
        1. Sau khi có Quyết định đạt Giải thưởng, trường hợp phát hiện cá nhân có
        hành vi vi phạm Quy chế Giải thưởng, bao gồm:
      </p>
      <p>
        - Làm giả, sử dụng tài liệu không hợp pháp hoặc khai báo không trung thực
        về thành tích trong hồ sơ đề cử.
      </p>
      <p>
        - Thành tích, công trình, sản phẩm có dấu hiệu vi phạm liêm chính khoa
        học, vi phạm đạo đức nghiên cứu, đã được cơ quan chuyên môn, cơ quan có
        thẩm quyền kết luận.
      </p>
      <p>
        - Có hành vi gây ảnh hưởng nghiêm trọng đến tính minh bạch, uy tín và
        chất lượng của giải thưởng.
      </p>
      <p>
        2. Đơn vị thường trực giải thưởng có trách nhiệm tổ chức rà soát, xác
        minh, tổng hợp hồ sơ, báo cáo và đề xuất Ban Bí thư Trung ương Đoàn TNCS
        Hồ Chí Minh xem xét, quyết định việc xử lý theo thẩm quyền.
      </p>
      <p>
        3. Căn cứ mức độ vi phạm, Ban Bí thư Trung ương Đoàn TNCS Hồ Chí Minh
        quyết định việc thu hồi giải thưởng, đồng thời thông báo công khai theo
        quy định trên các phương tiện thông tin phù hợp.
      </p>
      <p>
        4. Việc xử lý vi phạm phải bảo đảm nguyên tắc khách quan, công bằng, đúng
        quy định của pháp luật, bảo vệ quyền và lợi ích hợp pháp của các bên liên
        quan, đồng thời giữ gìn uy tín và giá trị của giải thưởng.
      </p>
      <p>
        5. Việc xem xét, xử lý theo Quy chế này tập trung vào các hành vi, thông
        tin, thành tích, công trình, sản phẩm, giải pháp đã khai báo trong hồ sơ
        đề cử của năm xét trao Giải thưởng. Các hành vi phát sinh sau thời điểm
        được trao Giải thưởng không thuộc phạm vi đánh giá hồ sơ của Hội đồng
        Giải thưởng năm xét trao Giải thưởng; trường hợp hành vi đó gây ảnh hưởng
        nghiêm trọng đến uy tín, danh dự của Giải thưởng hoặc tổ chức trao Giải
        thưởng thì Đơn vị thường trực Giải thưởng tổng hợp, báo cáo Ban Bí thư
        Trung ương Đoàn TNCS Hồ Chí Minh xem xét, quyết định theo thẩm quyền và
        quy định của pháp luật.
      </p>
      <Typography variant="h5">
        <strong>8. Công tác xét chọn Giải thưởng</strong>
      </Typography>
      <br />
      <Typography variant="h6">
        <i>
          <strong>8.1. Triển khai Giải thưởng</strong>
        </i>
      </Typography>
      <p>
        - Hằng năm, Đơn vị thường trực giải thưởng có trách nhiệm tham mưu tổ
        chức triển khai giải thưởng theo đúng Quy chế, gửi Quy chế và các văn bản
        hướng dẫn triển khai tới các tỉnh, thành đoàn, đoàn trực thuộc; các bộ,
        ngành, cơ quan, tổ chức liên quan; các viện nghiên cứu, trường đại học,
        doanh nghiệp uy tín trên phạm vi toàn quốc; Đại sứ quán, Ban Cán sự Đoàn
        TNCS Hồ Chí Minh, Hội Thanh niên, Sinh viên Việt Nam ở nước ngoài và đăng
        tải công khai trên Cổng thông tin điện tử Tài năng trẻ Quốc gia (
        <a href="http://tainangviet.vn/">http://tainangviet.vn/</a>).
      </p>
      <p>
        - Báo Tiền Phong, Báo Thanh Niên và các cơ quan báo chí của hệ thống Đoàn
        có trách nhiệm xây dựng và triển khai kế hoạch truyền thông cho Giải
        thưởng, bảo đảm đúng định hướng tuyên truyền về phát triển khoa học công
        nghệ, đổi mới sáng tạo và chuyển đổi số quốc gia.
      </p>
      <p>
        - Các cơ quan, đơn vị tìm kiếm, giới thiệu và hướng dẫn các cá nhân được
        giới thiệu đăng ký hồ sơ tham dự giải thưởng; đồng thời phối hợp với các
        cơ quan báo chí địa phương, ngành tổ chức tuyên truyền về giải thưởng và
        các gương mặt tài năng trẻ tham dự giải thưởng.
      </p>
      <p>
        - Đơn vị thường trực giải thưởng tiếp nhận, hướng dẫn hoàn thiện, rà soát
        tính hợp lệ và tổng hợp hồ sơ đăng ký tham gia giải thưởng theo đúng Quy
        chế và các văn bản hướng dẫn có liên quan.
      </p>
      <Typography variant="h6">
        <i>
          <strong>8.2. Đăng ký tham gia Giải thưởng&nbsp;</strong>
        </i>
      </Typography>
      <p>
        Ứng viên đăng ký tham gia giải thưởng bằng hình thức trực tuyến trên hệ
        thống đăng ký trực tuyến của giải thưởng. Việc đăng ký, tiếp nhận và xử
        lý hồ sơ được thực hiện thống nhất trên môi trường số, bảo đảm công khai,
        minh bạch, thuận tiện cho ứng viên và đơn vị tham gia. Các tài liệu,
        thông tin cần cung cấp trên hệ thống đăng ký gồm:
      </p>
      <p>
        - Công văn của cơ quan, đơn vị đề cử, giới thiệu (bản scan, có ký tên,
        đóng dấu). Cơ quan, đơn vị đề cử, giới thiệu bao gồm: các ban, đơn vị
        Trung ương Đoàn; các tỉnh, thành đoàn, đoàn trực thuộc; Trung ương Hội
        Liên hiệp Thanh niên Việt Nam, Trung ương Hội Sinh viên Việt Nam; các bộ,
        ngành, các viện nghiên cứu, trường đại học, doanh nghiệp, cơ quan báo
        chí; Đại sứ quán Việt Nam hoặc Ban Cán sự Đoàn Thanh niên, Hội Thanh
        niên, Sinh viên Việt Nam ở nước ngoài (đối với công dân Việt Nam ở nước
        ngoài); Đơn vị thường trực giải thưởng trực tiếp giới thiệu các cá nhân
        tiêu biểu.
      </p>
      <p>
        - Kê khai thành tích cá nhân và đính kèm bản scan thành tích cá nhân có
        xác nhận của thủ trưởng cơ quan, đơn vị quản lý trực tiếp (bản scan, có
        ký tên, đóng dấu), bảo đảm tính trung thực, chính xác và liêm chính khoa
        học.
      </p>
      <p>
        - Bản scan các tài liệu chứng minh về thành tích, kết quả nghiên cứu, áp
        dụng thực tiễn như: bằng độc quyền sáng chế, bằng độc quyền giải pháp hữu
        ích; xác nhận, nhận xét, đánh giá về hiệu quả đạt được của các đơn vị áp
        dụng công trình; các bản mô phỏng (demo), hình ảnh, tư liệu số minh chứng
        của cá nhân trong hoạt động và công tác thuộc lĩnh vực đăng ký xét Giải
        thưởng.
      </p>
      <p>
        - Báo cáo tóm tắt công trình nghiên cứu, giải pháp công nghệ, sáng chế,
        sản phẩm khoa học công nghệ tiêu biểu trong lĩnh vực đăng ký xét Giải
        thưởng theo mẫu hướng dẫn của Ban Tổ chức Giải thưởng kèm theo tài liệu
        thẩm định, nghiệm thu, đánh giá, xác nhận ứng dụng thực tiễn, thương mại
        hóa hoặc tài liệu chứng minh hiệu quả, tác động của công trình, sản phẩm,
        giải pháp.
      </p>
      <p>
        - Ứng viên gửi 01 video giới thiệu cá nhân (không quá 02 phút) phục vụ
        công tác truyền thông và đánh giá xét chọn giải thưởng (giới thiệu về cá
        nhân, các thành tích, công trình nghiên cứu khoa học hoặc giải pháp công
        nghệ tiêu biểu, giá trị khoa học, khả năng ứng dụng và tác động xã hội);
        01 ảnh chân dung và tối thiểu 05 ảnh về hoạt động cá nhân trong học tập,
        nghiên cứu và công tác. Lưu ý: video và các hình ảnh hoạt động phải bảo
        đảm chất lượng, âm thanh rõ, hình thức đẹp, chuyên nghiệp, dung lượng và
        định dạng phù hợp để Ban Tổ chức sử dụng, thiết kế các sản phẩm truyền
        thông trên các nền tảng số.
      </p>
      <Typography variant="h6">
        <i>
          <strong>8.3. Hội đồng Giải thưởng&nbsp;</strong>
        </i>
      </Typography>
      <p>
        - Hội đồng Giải thưởng Khoa học công nghệ Quả Cầu Vàng (sau đây gọi tắt
        là Hội đồng Giải thưởng) là cơ quan tham mưu xét chọn Giải thưởng do Ban
        Bí thư Trung ương Đoàn TNCS Hồ Chí Minh quyết định thành lập theo đề xuất
        của Đơn vị thường trực giải thưởng.
      </p>
      <p>
        - Hội đồng Giải thưởng có nhiệm vụ xem xét, đánh giá và lựa chọn các cá
        nhân có thành tích xuất sắc tiêu biểu trong từng lĩnh vực xét giải thưởng
        trình Ban Bí thư Trung ương Đoàn TNCS Hồ Chí Minh xem xét quyết định trao
        tặng giải thưởng.
      </p>
      <p>
        - Hội đồng Giải thưởng gồm các cán bộ quản lý, chuyên gia, nhà khoa học
        có trình độ chuyên môn về các lĩnh vực xét giải thưởng (không đăng ký
        tham gia giải thưởng trong năm đó). Hội đồng có cơ cấu như sau:
      </p>
      <p>
        + Chủ tịch Hội đồng giải thưởng: Đại diện Ban Bí thư Trung ương Đoàn TNCS
        Hồ Chí Minh.
      </p>
      <p>
        + Các Phó Chủ tịch Hội đồng giải thưởng: Đại diện lãnh đạo cấp vụ chuyên
        môn của Bộ Khoa học và Công nghệ và lãnh đạo Trung tâm Phát triển Khoa
        học, Công nghệ và Tài năng trẻ.
      </p>
      <p>
        + Các thành viên Hội đồng giải thưởng: Đại diện các bộ, ngành liên quan;
        các chuyên gia, nhà khoa học, nhà quản lý thuộc các lĩnh vực xét giải
        thưởng; đại diện một số cơ quan truyền thông, nhà tài trợ (nếu có).
      </p>
      <Typography variant="h6">
        <i>
          <strong>8.4. Ban Thư ký Giải thưởng</strong>
        </i>
      </Typography>
      <p>
        - Ban Thư ký Giải thưởng là cơ quan tham mưu, giúp việc cho Hội đồng Giải
        thưởng do Ban Bí thư Trung ương Đoàn TNCS Hồ Chí Minh quyết định thành
        lập theo đề xuất của Đơn vị thường trực giải thưởng, hoạt động theo
        nguyên tắc khách quan, độc lập về chuyên môn, bảo đảm liêm chính khoa học
        và bảo mật thông tin. Thành viên Ban Thư ký là các chuyên gia, nhà khoa
        học (không đăng ký tham gia giải thưởng của năm đó) có trình độ chuyên
        môn phù hợp với các lĩnh vực xét giải thưởng.
      </p>
      <p>
        - Ban Thư ký có nhiệm vụ phân loại, kiểm tra, rà soát tính đầy đủ, hợp lệ
        của hồ sơ, đánh giá sơ bộ theo các tiêu chí của giải thưởng và báo cáo
        tổng hợp, đề xuất trình Hội đồng Giải thưởng xem xét. Nhiệm vụ cụ thể của
        các thành viên Ban Thư ký do Trưởng Ban Thư ký phân công. Ban Thư ký có
        thể được tổ chức thành các tổ/nhóm chuyên môn theo từng lĩnh vực xét giải
        thưởng nhằm nâng cao hiệu quả, chất lượng thẩm định.
      </p>
      <Typography variant="h5">
        <strong>9. Kinh phí tổ chức Giải thưởng</strong>
      </Typography>
      <p>
        1. Kinh phí tổ chức xét chọn và trao giải thưởng được bảo đảm từ nguồn
        kinh phí hoạt động khoa học công nghệ hằng năm theo quy định và từ các
        nguồn tài trợ hợp pháp từ tổ chức, cá nhân trong và ngoài nước.
      </p>
      <p>
        2. Việc tiếp nhận, quản lý và sử dụng kinh phí tổ chức giải thưởng, bao
        gồm: kinh phí từ ngân sách nhà nước và kinh phí tài trợ được thực hiện
        theo đúng quy định của pháp luật hiện hành và quy định của Trung ương
        Đoàn TNCS Hồ Chí Minh.
      </p>
      <Typography variant="h5">
        <strong>
          10. Nguyên tắc bảo đảm liêm chính khoa học và phòng ngừa xung đột lợi
          ích
        </strong>
      </Typography>
      <p>
        1. Quá trình đề cử, xét chọn và trao giải thưởng phải bảo đảm các nguyên
        tắc liêm chính khoa học, khách quan, minh bạch, không thiên vị và tuân
        thủ các chuẩn mực đạo đức nghiên cứu.
      </p>
      <p>
        2. Thành viên Hội đồng Giải thưởng, Ban Thư ký Giải thưởng và các tổ
        chức, cá nhân có liên quan phải chủ động báo cáo và không tham gia đánh
        giá, thẩm định đối với các hồ sơ có xung đột lợi ích trực tiếp hoặc gián
        tiếp. Xung đột lợi ích bao gồm trường hợp có quan hệ hướng dẫn khoa học,
        đồng tác giả, cùng nhóm nghiên cứu trực tiếp, quan hệ quản lý trực tiếp,
        quan hệ thân thích, lợi ích tài chính hoặc các quan hệ khác có thể ảnh
        hưởng đến tính khách quan, độc lập trong quá trình đánh giá, thẩm định hồ
        sơ.
      </p>
      <p>
        3. Trường hợp phát sinh tình huống chưa được quy định cụ thể, Hội đồng
        Giải thưởng báo cáo Ban Bí thư Trung ương Đoàn TNCS Hồ Chí Minh xem xét,
        quyết định./.
      </p>

      <Typography
        variant="h5"
        style={{
          color: "black",
          textAlign: "end",
          fontFamily: "SFProDisplay-Bold",
        }}
      >
        <strong>ĐƠN VỊ THƯỜNG TRỰC GIẢI THƯỞNG</strong>
      </Typography>
    </div>
  );
}
